var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-pdf--bg", class: _vm.showModal ? "visible" : "" },
    [
      _c("div", { staticClass: "modal-pdf--layout" }, [
        _c("div", { staticClass: "modal-border" }, [
          !_vm.loading
            ? _c("div", { staticClass: "modal-close" }, [
                _c("p", [_vm._v(_vm._s(_vm.title))]),
                _c("p", { on: { click: _vm.closedModal } }, [
                  _c("strong", [_vm._v("X")]),
                  _c("span", [_vm._v("Cerrar")])
                ])
              ])
            : _vm._e(),
          _c("iframe", {
            attrs: {
              src: _vm.url,
              id: "modal-pdf",
              title: "GPS Chile File",
              allow:
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
              allowfullscreen: ""
            },
            on: { load: _vm.handleLoad }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }